import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import professionCases from 'helpers/professionCases';

const Responsibilities = styled('section')(({ theme }) => ({
  borderRadius: 15,
  border: `2px solid ${theme.palette.primary.main}`,
  backgroundColor: theme.palette.white.main,
  marginBottom: 25
}));

const Title = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  fontSize: 24,
  [theme.breakpoints.down('sm')]: {
    lineHeight: '34px',
    padding: '16px 25px',
    textAlign: 'left'
  }
}));

const Content = styled(Typography)(({ theme }) => ({
  padding: 28,
  borderTop: `1px solid ${theme.palette.textDisabled.main}`,
  textAlign: 'left',
  fontSize: 16,
  [theme.breakpoints.down('md')]: {
    padding: '28px 50px'
  },
  [theme.breakpoints.down('sm')]: {
    padding: '16px 25px'
  }
}));

const StepsWrapper = styled('div')(() => ({
  padding: '28px',
  paddingTop: 0,
  paddingBottom: 0,
  textAlign: 'left'
}));

const HowToTitle = styled(Typography)(() => ({
  textAlign: 'left',
  fontSize: 18,
  marginBottom: 5,
  lineHeight: 'normal'
}));

const HowToDescription = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  marginBottom: 30,
  fontSize: 16,
  [theme.breakpoints.down('sm')]: {
    marginBottom: 20
  }
}));

const Outro = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  padding: 28,
  paddingTop: 0,
  fontSize: 16,
  paddingBottom: 50,
  [theme.breakpoints.down('md')]: {
    paddingBottom: 30
  }
}));

const StepsToSwitch = ({ professionInfo, t }) => {
  return (
    <Responsibilities>
      <Title variant={'h2'}>
        {t('StepsToSwitch', professionCases(professionInfo, 'instrumental'))}
      </Title>
      <Content variant="body1">{professionInfo?.workHowToBecome?.intro}</Content>
      <StepsWrapper>
        {(professionInfo?.workHowToBecome?.options || []).map((option, index) => (
          <div key={option?._id}>
            <HowToTitle variant="h3">
              {index + 1}
              {'. '}
              {option?.name}
            </HowToTitle>
            <HowToDescription variant="body1">{option?.description}</HowToDescription>
          </div>
        ))}
      </StepsWrapper>
      <Outro variant="body1">{professionInfo?.workHowToBecome?.outro}</Outro>
    </Responsibilities>
  );
};

export default StepsToSwitch;
